/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Folder_InvalidInputs */

const fr_api_drive_folder_invalid = /** @type {(inputs: Api_Drive_Folder_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un dossier Drive.`)
};

const en_api_drive_folder_invalid = /** @type {(inputs: Api_Drive_Folder_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a Drive folder.`)
};

/**
* | output |
* | --- |
* | "Select a Drive folder." |
*
* @param {Api_Drive_Folder_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_folder_invalid = /** @type {((inputs?: Api_Drive_Folder_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Folder_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_folder_invalid(inputs)
	return fr_api_drive_folder_invalid(inputs)
});